/**
 * Notifications API
 */

import { apiClient, ApiResponse, ApiError, ApiErrorResponse } from './client';

export interface Notification {
  userId: string;
  notificationId: string;
  message: string;
  link: string;
  isRead: boolean;
  createdAt: number;
}

export interface NotificationsResponse {
  notifications: Notification[];
  unreadCount: number;
}

export const notificationsApi = {
  /**
   * List the current user's notifications (newest first, max 50)
   */
  async list(): Promise<NotificationsResponse> {
    const response = await apiClient.get<ApiResponse<NotificationsResponse>>('/notifications');
    if (!response.success) throw new ApiError(response as unknown as ApiErrorResponse);
    return response.data;
  },

  /**
   * Mark all notifications as read
   */
  async markAllRead(): Promise<void> {
    const response = await apiClient.post<ApiResponse<void>>('/notifications/read-all', {});
    if (!response.success) throw new ApiError(response as unknown as ApiErrorResponse);
  },

  /**
   * Delete a single notification
   */
  async delete(notificationId: string): Promise<void> {
    const response = await apiClient.delete<ApiResponse<void>>(`/notifications/${notificationId}`);
    if (!response.success) throw new ApiError(response as unknown as ApiErrorResponse);
  },
};
